/**
 * BR Header JavaScript - FIXED PANEL SYSTEM
 * File: assets/br-header.js
 */

class BRHeader {
  constructor() {
    this.header = document.querySelector('.br-header-wrapper');
    this.mobileToggle = document.querySelector('.br-header__mobile-toggle');
    this.mobileMenu = document.getElementById('brMobileMenu');
    this.mobileClose = document.getElementById('brMobileClose');
    this.mobileOverlay = document.getElementById('brMobileOverlay');
    this.megaMenus = document.querySelectorAll('.br-megamenu');
    this.cartCount = document.querySelector('.br-header__cart-count');
    
    this.lastScrollTop = 0;
    this.isScrolling = false;
    this.headerHeight = this.header ? this.header.offsetHeight : 0;
    
    this.init();
  }
  
  init() {
    this.setupMobileMenu();
    this.setupMegaMenu();
    this.setupMegaMenuPanels();
    this.setupScrollBehavior();
    this.setupSearch();
    this.setupCartUpdates();
    this.setupAccessibility();
    this.setupRoomCarousel();
  }
  
  /**
   * Mobile Menu Setup
   */
  setupMobileMenu() {
    // Toggle mobile menu
    if (this.mobileToggle) {
      this.mobileToggle.addEventListener('click', () => this.openMobileMenu());
    }
    
    // Close mobile menu
    if (this.mobileClose) {
      this.mobileClose.addEventListener('click', () => this.closeMobileMenu());
    }
    
    // Close on overlay click
    if (this.mobileOverlay) {
      this.mobileOverlay.addEventListener('click', () => this.closeMobileMenu());
    }
    
    // Setup mobile submenu toggles - OPDELT VERSION MED SMOOTH SCROLL

    // 1. HOVEDKATEGORIER - Luk andre hovedkategorier når én åbnes
    const mainCategories = document.querySelectorAll('.br-mobile-menu__details');
    mainCategories.forEach(details => {
      details.addEventListener('toggle', (e) => {
        if (details.open) {
          // Luk alle andre hovedkategorier
          mainCategories.forEach(other => {
            if (other !== details && other.open) {
              other.open = false;
            }
          });
          
          // Smooth scroll til det åbnede element efter en lille delay
          setTimeout(() => {
            details.scrollIntoView({ 
              behavior: 'smooth', 
              block: 'nearest',
              inline: 'nearest'
            });
          }, 100);
        }
      });
    });

    // 2. UNDERKATEGORIER - Luk andre underkategorier INDEN FOR samme hovedkategori
    const subCategories = document.querySelectorAll('.br-mobile-menu__subdetails');
    subCategories.forEach(details => {
      details.addEventListener('toggle', (e) => {
        if (details.open) {
          // Find parent hovedkategori
          const parentCategory = details.closest('.br-mobile-menu__details');
          if (parentCategory) {
            // Find alle underkategorier i SAMME hovedkategori
            const siblingSubCategories = parentCategory.querySelectorAll('.br-mobile-menu__subdetails');
            siblingSubCategories.forEach(other => {
              if (other !== details && other.open) {
                other.open = false;
              }
            });
          }
          
          // Smooth scroll til det åbnede element
          setTimeout(() => {
            details.scrollIntoView({ 
              behavior: 'smooth', 
              block: 'nearest',
              inline: 'nearest'
            });
          }, 100);
        }
      });
    });
    
    // Prevent body scroll when menu is open
    this.setupBodyScrollLock();
  }
  
  openMobileMenu() {
    if (this.mobileMenu) {
      this.mobileMenu.classList.add('active');
      this.mobileOverlay?.classList.add('active');
      document.body.classList.add('mobile-menu-open');
      
      // Focus management
      this.mobileMenu.focus();
      
      // Trap focus in menu
      this.trapFocus(this.mobileMenu);
    }
  }
  
  closeMobileMenu() {
    if (this.mobileMenu) {
      this.mobileMenu.classList.remove('active');
      this.mobileOverlay?.classList.remove('active');
      document.body.classList.remove('mobile-menu-open');
      
      // Return focus to toggle button
      this.mobileToggle?.focus();
      
      // Release focus trap
      this.releaseFocus();
    }
  }
  
  setupBodyScrollLock() {
    let scrollPosition = 0;
    
    const lockScroll = () => {
      scrollPosition = window.pageYOffset;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPosition}px`;
      document.body.style.width = '100%';
    };
    
    const unlockScroll = () => {
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('top');
      document.body.style.removeProperty('width');
      window.scrollTo(0, scrollPosition);
    };
    
    // Override open/close methods
    const originalOpen = this.openMobileMenu.bind(this);
    const originalClose = this.closeMobileMenu.bind(this);
    
    this.openMobileMenu = () => {
      originalOpen();
      lockScroll();
    };
    
    this.closeMobileMenu = () => {
      originalClose();
      unlockScroll();
    };
  }
  
  /**
   * Room Carousel Setup - SIMPLE FREE SWIPE
   */
  setupRoomCarousel() {
    const carousel = document.querySelector('.br-mobile-menu__rooms-carousel');
    
    if (!carousel) return;
    
    // Fjern scroll-snap og lad native scrolling håndtere det
    carousel.style.scrollSnapType = 'none';
    carousel.style.WebkitOverflowScrolling = 'touch'; // For iOS smooth scrolling
    
    // That's it! Native touch scrolling håndterer resten
  }
  
  /**
   * Mega Menu Setup
   */
  setupMegaMenu() {
    this.megaMenus.forEach(menu => {
      const link = menu.querySelector('.br-header__category-link');
      const content = menu.querySelector('.br-megamenu__content');
      
      // Prevent default click on main category links with dropdowns
      if (link && content) {
        link.addEventListener('click', (e) => {
          // Kun prevent default hvis det er en hover menu
          if (window.innerWidth > 989) {
            e.preventDefault();
          }
        });
      }
      
      // Initialize first panel as active when menu opens
      menu.addEventListener('mouseenter', () => {
        this.initializeDefaultPanel(menu);
      });
    });
  }
  
  /**
   * Initialize default panel for mega menu
   */
  initializeDefaultPanel(menu) {
    const sidebarItems = menu.querySelectorAll('.br-megamenu__sidebar-item[data-target]');
    const panels = menu.querySelectorAll('.br-megamenu__panel');
    
    // Check if any panel is already active
    const hasActivePanel = Array.from(panels).some(panel => panel.classList.contains('active'));
    
    if (!hasActivePanel && sidebarItems.length > 0 && panels.length > 0) {
      // Set first item and panel as active
      sidebarItems[0].classList.add('active');
      panels[0].classList.add('active');
    }
  }
  
  /**
   * Mega Menu Panel Switching - SIMPLIFIED VERSION
   */
  setupMegaMenuPanels() {
    // For hver mega menu
    this.megaMenus.forEach(menu => {
      const sidebarItems = menu.querySelectorAll('.br-megamenu__sidebar-item[data-target]');
      const panels = menu.querySelectorAll('.br-megamenu__panel');
      
      // Initialize first panel as active
      if (sidebarItems.length > 0 && panels.length > 0) {
        sidebarItems[0].classList.add('active');
        panels[0].classList.add('active');
      }
      
      sidebarItems.forEach(item => {
        // CLICK handler - permanent switch
        item.addEventListener('click', (e) => {
          e.preventDefault();
          
          const targetHandle = item.dataset.target;
          const targetPanel = menu.querySelector(`[data-panel="${targetHandle}"]`);
          
          if (targetPanel) {
            // Remove active class from ALL items and panels
            sidebarItems.forEach(i => i.classList.remove('active'));
            panels.forEach(p => p.classList.remove('active'));
            
            // Add active class to clicked item and corresponding panel
            item.classList.add('active');
            targetPanel.classList.add('active');
          }
        });
      });
    });
  }
  
  /**
   * Scroll Behavior
   */
  setupScrollBehavior() {
    if (!this.header) return;
    
    let ticking = false;
    
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // Add scrolled class for styling
      if (scrollTop > 10) {
        this.header.classList.add('scrolled');
      } else {
        this.header.classList.remove('scrolled');
      }
      
      // Close mega menus when scrolling
      if (scrollTop > this.lastScrollTop && scrollTop > this.headerHeight) {
        this.megaMenus.forEach(menu => {
          const content = menu.querySelector('.br-megamenu__content');
          if (content) {
            content.style.display = 'none';
            setTimeout(() => {
              content.style.display = '';
            }, 100);
          }
        });
      }
      
      this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    };
    
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    });
  }
  
  /**
   * Search Functionality
   */
  setupSearch() {
    const searchInput = document.querySelector('.br-header__search-input');
    const mobileSearchInput = document.querySelector('.br-header__search-input-mobile');
    
    // Sync search values between desktop and mobile
    if (searchInput && mobileSearchInput) {
      searchInput.addEventListener('input', (e) => {
        mobileSearchInput.value = e.target.value;
      });
      
      mobileSearchInput.addEventListener('input', (e) => {
        searchInput.value = e.target.value;
      });
    }
    
    // Handle search submit
    const searchForms = document.querySelectorAll('.br-header__search-form, .br-header__search-form-mobile');
    searchForms.forEach(form => {
      form.addEventListener('submit', (e) => {
        const input = form.querySelector('input[type="search"]');
        if (input && !input.value.trim()) {
          e.preventDefault();
          input.focus();
        }
      });
    });
  }
  
  /**
   * Cart Updates
   */
  setupCartUpdates() {
  // Listen for cart updates — always fetch real count from server
  // instead of relying on e.detail.count which may be undefined
    document.addEventListener('cart:updated', (e) => {
      if (typeof e.detail?.count === 'number') {
        this.updateCartCount(e.detail.count);
      } else {
        this.fetchCartData();
      }
    });
    
    // Listen for Shopify cart API calls
    const originalFetch = window.fetch.bind(window);
    window.fetch = (...args) => {
      return originalFetch.apply(this, args)
        .then(response => {
          try {
            const url = args[0];
            if (url && (url.includes('/cart/add') || url.includes('/cart/update') || url.includes('/cart/change'))) {
              // Fetch cart data to update count
              this.fetchCartData();
            }
          } catch (error) {
            console.error('BR Header cart update error:', error);
          }
          return response;
        })
        .catch(error => {
          console.error('BR Header fetch error:', error);
          throw error; // Re-throw so product-form.js can handle it
        });
    };
  }
  
  fetchCartData() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(data => {
        this.updateCartCount(data.item_count);
      })
      .catch(err => console.error('Error fetching cart:', err));
  }
  
  updateCartCount(count) {
    const cartCounts = document.querySelectorAll('.br-header__cart-count');
    cartCounts.forEach(cartCount => {
      if (count > 0) {
        cartCount.textContent = count > 99 ? '99+' : count;
        cartCount.style.display = 'block';
      } else {
        cartCount.style.display = 'none';
      }
    });
  }
  
  /**
   * Accessibility
   */
  setupAccessibility() {
    // Add ARIA attributes for mega menu panels
    this.megaMenus.forEach(menu => {
      const sidebarItems = menu.querySelectorAll('.br-megamenu__sidebar-item[data-target]');
      const panels = menu.querySelectorAll('.br-megamenu__panel');
      
      sidebarItems.forEach((item, index) => {
        const targetHandle = item.dataset.target;
        const targetPanel = menu.querySelector(`[data-panel="${targetHandle}"]`);
        
        if (targetPanel) {
          // Add ARIA attributes
          item.setAttribute('role', 'tab');
          item.setAttribute('aria-controls', `panel-${targetHandle}`);
          item.setAttribute('aria-selected', item.classList.contains('active') ? 'true' : 'false');
          
          targetPanel.setAttribute('role', 'tabpanel');
          targetPanel.setAttribute('id', `panel-${targetHandle}`);
          targetPanel.setAttribute('aria-labelledby', `tab-${targetHandle}`);
          item.setAttribute('id', `tab-${targetHandle}`);
        }
      });
    });
    
    // Keyboard navigation for mobile menu
    if (this.mobileMenu) {
      this.mobileMenu.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closeMobileMenu();
        }
      });
    }
  }
  
  /**
   * Focus Management
   */
  trapFocus(element) {
    const focusableElements = element.querySelectorAll(
      'a[href], button, textarea, input[type="text"], input[type="search"], input[type="radio"], input[type="checkbox"], select, details summary'
    );
    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];
    
    this.focusTrapHandler = (e) => {
      if (e.key !== 'Tab') return;
      
      if (e.shiftKey) {
        if (document.activeElement === firstFocusable) {
          lastFocusable.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === lastFocusable) {
          firstFocusable.focus();
          e.preventDefault();
        }
      }
    };
    
    element.addEventListener('keydown', this.focusTrapHandler);
  }
  
  releaseFocus() {
    if (this.mobileMenu && this.focusTrapHandler) {
      this.mobileMenu.removeEventListener('keydown', this.focusTrapHandler);
      this.focusTrapHandler = null;
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new BRHeader();
  });
} else {
  new BRHeader();
}

// Export for use in other scripts
window.BRHeader = BRHeader;